import { motion } from "framer-motion";

export const reveal = (delay = 0) => ({
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
  transition: { duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] },
});

export const SectionHeading = ({ eyebrow, title, accent, description, testid }) => (
  <motion.div {...reveal()} className="mb-16 max-w-3xl">
    <p className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.3em] text-orange-400/80">
      {eyebrow}
    </p>
    <h2
      data-testid={testid}
      className="font-syne text-2xl font-extrabold uppercase tracking-tight text-zinc-100 sm:text-3xl lg:text-4xl"
    >
      {title}{" "}
      {accent && (
        <span className="text-pumpkin drop-shadow-[0_0_18px_rgba(255,107,0,0.45)]">
          {accent}
        </span>
      )}
    </h2>
    {description && (
      <p className="mt-5 text-base leading-relaxed text-zinc-400">{description}</p>
    )}
  </motion.div>
);
